import { render } from "./fsRaceSignCheck.vue?vue&type=template&id=8053dbfa&scoped=true"
import script from "./fsRaceSignCheck.vue?vue&type=script&lang=js"
export * from "./fsRaceSignCheck.vue?vue&type=script&lang=js"

import "./fsRaceSignCheck.vue?vue&type=style&index=0&id=8053dbfa&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8053dbfa"]])

export default __exports__